module.exports = __webpack_public_path__ + "static/img/for-rare-website-news-feb-2023.b9e267f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/for-rare-website-news-feb-2023.jpg
// module id = Fbjx
// module chunks = 0